import type { PropsWithChildren } from "react";
import { Outlet } from "react-router-dom";

import { usePortalUserStore } from "@/app/stores";
import { AmazonChatButton } from "@/shared/components";
import { Navbar } from "./navbar";

export const Layout = ({ children }: PropsWithChildren) => {
  const hasActiveSubscription = usePortalUserStore(
    (state) => state.hasActiveSubscription,
  );

  return (
    <div className="flex h-dvh flex-col overflow-hidden bg-white lg:flex-row">
      <Navbar />
      <main className="relative flex grow overflow-y-auto" id="scrollElement">
        {children ?? <Outlet />}
      </main>

      {hasActiveSubscription && <AmazonChatButton />}
    </div>
  );
};
